@if (showActionsBar(true)) {
  <div class="actions-bar" [ngClass]="{ 'mod-open-caret': canOpen }">
    <div class="actions-bar-text">
      <span class="actions-bar-icon bpi__icon-bell"></span>
      @if (!isWithdrawal()) {
        {{ transaction?.getStatus() | translate }}
      }
      @if (showResendEmailLink()) {
        @if (!isSendFiat) {
          <span class="pr-10">{{ "please_email_confirm" | translate }}</span>
          <a (click)="resendEmail()" class="actions-bar-link">{{ "resend_email" | translate }}</a>
        } @else {
          {{ "send_waiting_confirmation" | translate }}
          <a (click)="resendSmsPin()" class="actions-bar-link">{{ "send_waiting_resend_sms" | translate }}</a>
        }
      }
      @if (isProcessingAmazonTx()) {
        <a (click)="resendAmazon()" class="actions-bar-link">
          {{ "resend_amazon_voucher_code_email" | translate }}
        </a>
      }
    </div>
    <div class="actions-bar-buttons">
      @if (showConfirmButtons()) {
        @if (isConfirmable()) {
          <a (click)="restoreDeposit()" class="btn btn-white btn-transparent">
            {{ "continue_finish_deposit" | translate }}
          </a>
        }
        @if (isPayable() && (isPaymentOptionSupported$ | async)) {
          <a
            (click)="payTransaction()"
            class="btn btn-white btn-transparent"
            >
            {{ "pay_deposit" | translate }}
          </a>
        }
      }
      @if (hasAction()) {
        @if (isCancelable()) {
          <a (click)="cancel()" class="btn">{{ "cancel" | translate }}</a>
        }
      }
    </div>
  </div>
}
